// removed by extract-text-webpack-plugin
module.exports = {"attributes-container":"Attributes__attributes-container___xzlTO","attributes-wrapper":"Attributes__attributes-wrapper___3cS0g","attribute":"Attributes__attribute___3ATW-","disabled":"Attributes__disabled___pYCIb","row":"Attributes__row___1NXJW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Attributes/Attributes.css
// module id = 693
// module chunks = 0